/* Ott-common */
import { ClientType } from '@dtvgo/backend-service/normalize';
import { Platform as AemPlatform } from '@dtvgo/aem-service';

/* Utils */
import { toggleCursorVisibility } from '../../../providers/CursorStateProvider';
import { closeApp, noOp } from '../../functions';
import {
  ConnectionType,
  DrmKeySystem,
  Platform,
  MsToWaitOnReconnection,
} from '../../constants';
import defaultKeys from '../common/defaultKeys';

const D_KEY = 'd';
const D_KEY_CODE = 68;

function addKeydownBackdoorListenerToChangeCursorVisibility() {
  document.addEventListener('keydown', ({
    key, ctrlKey, altKey, keyCode,
  }) => {
    if ((key.toLowerCase() === D_KEY || keyCode === D_KEY_CODE) && ctrlKey && altKey) {
      toggleCursorVisibility();
    }
  }, false);
}

function init() {
  addKeydownBackdoorListenerToChangeCursorVisibility();
}

async function getConnectionStatus({
  subscribe,
  onSuccess,
  onFailure,
}) {
  try {
    const onNetworkStateChange = () => {
      const connectionType = ConnectionType[navigator.connection?.type?.toUpperCase()];
      const isConnected = navigator.onLine ?? true;
      onSuccess({ isConnected, connectionType });
    };
    if (subscribe) {
      window.addEventListener('online', onNetworkStateChange);
      window.addEventListener('offline', onNetworkStateChange);
      if (navigator.connection) {
        navigator.connection.addEventListener('change', onNetworkStateChange);
      }
    }
    onNetworkStateChange();
  } catch (error) {
    onFailure(error);
  }
}

export default {
  osName: '',
  platformName: 'HTML5',
  appName: 'html5_default',
  signupUrl: '',
  aemPlatform: AemPlatform.WEBOS,
  clientType: ClientType.SMART_TV,
  isThisPlatform: () => false,
  init,
  // App and device info
  getAppId: () => '',
  getDeviceInfo: () => ({}),
  getTimezone: () => Intl.DateTimeFormat().resolvedOptions().timeZone,
  getUrlToOpen: () => undefined,
  // Functions
  closeApp,
  sendAppToBackground: closeApp,
  getConnectionStatus,
  msToWaitOnReconnection: MsToWaitOnReconnection[Platform.DEFAULT],
  saveCredentials: noOp,
  getCredentials: () => undefined,
  removeCredentials: noOp,
  getSessionTokenAlternative: () => undefined,
  removeSessionTokenAlternative: noOp,
  getAccessTokenAlternative: () => undefined,
  removeAccessTokenAlternative: noOp,
  // Player related options
  drmKeySystem: DrmKeySystem.WIDEVINE,
  isPlayreadyUtf8AndPlain: false,
  loadDrmAgent: () => true,
  getAdditionalBitmovinModules: () => [],
  // Conviva
  npaw: {
    name: 'HTML5',
  },
  // Keyboard state change
  addKeyboardStateChangeListener: noOp,
  addRelaunchEventListener: noOp,
  // Key codes
  keyCodes: defaultKeys,
  datadog: {
    useCrossSiteSessionCookie: false,
  },
  getAppVersion: () => '',
};
